// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, maybe } from "@altostra/type-validations";
import { boolean, string, number } from "@altostra/type-validations/lib/primitives";

export const isEngagementListEmailSettingsResult = arrayOf(
  objectOf({
    display_name: maybe(string),
    address: string,
    default: maybe(boolean),
    ip_pool_name: maybe(string),
    ip_pool_id: maybe(string),
    esp: number,
  })
);
